import "./dashboard-sections.css";
import DashboardCard from "./DashboardCard";

const EvapBox = ({ label, value, unit }) => (
  <div className="db-evap-box">
    <div className="db-evap-label">{label}</div>
    <div className="db-evap-value neutral">
      {value ?? "—"}{unit && <span className="db-metric-unit"> {unit}</span>}
    </div>
  </div>
);

const RunningTotalsExtra = ({ data = {}, isLoading = false }) => {
  const d = data;

  const prcsMetrics  = data?.processing_metrics ?? [];

  return (
    <div className="rte-wrapper">

      {/* Processing */}
      <DashboardCard title="Processing">
        <div className="db-evap-row">
          <EvapBox label="TOTAL ACCEPTED KG"      value={prcsMetrics?.total_accepted_in_processing} unit="kg" />
          <EvapBox label="TOTAL CASES PROCESSED"  value={prcsMetrics?.total_cases_processed} />
          <EvapBox label="GAS LITERS"   value={prcsMetrics?.total_gas_consumed_ltr} unit="L" />
          <EvapBox label="GAS COSTING"  value={prcsMetrics?.total_gas_cost ? `$${prcsMetrics.total_gas_cost}` : "0"} />
        </div>
      </DashboardCard>

      {/* Packing */}
      <DashboardCard title="Packing">
        <div className="db-evap-row">
          <EvapBox label="PRIME CHEEKS PACKED"       value={d?.prime_cheeks_packed}       unit="kg" />
          <EvapBox label="PRIME STRIPS PACKED"       value={d?.prime_strips_packed}       unit="kg" />
          <EvapBox label="TOTAL BOXES PACKED PRIME"  value={d?.total_boxes_packed_prime}            />
        </div>
        <div className="db-evap-row" style={{ borderTop: "1px solid #f0f1f3", paddingTop: 12 }}>
          <EvapBox label="BROKERING KG PRIME"        value={d?.brokering_kg_prime}        unit="kg" />
          <EvapBox label="BROKERING 2ND & PIECES"    value={d?.brokering_kg_2nd}          unit="kg" />
          <EvapBox label="PASTING BOXES (BROK+PACK)" value={d?.pasting_boxes_total}                 />
        </div>
      </DashboardCard>

    </div>
  );
};

export default RunningTotalsExtra;
